// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"8fcd00ca","470":"6de38bb2"}[chunkId] + ".chunk.js";
};